import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Stricter email regex (checks for domain with dot)
export function strictEmailValidator(): ValidatorFn {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return (control: AbstractControl): ValidationErrors | null => {
    const { value } = control;
    if (!value) {
      return null;
    }

    return emailRegex.test(value) ? null : { email: true };
  };
}
